module.exports = __webpack_public_path__ + "static/media/021-rain-1.79933930.svg";